import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import WithRouter, { type RouterProps } from "@/components/common/WithRouter"
import useMenuItems, { type MenuItem } from "@/hooks/useMenuItems"

interface HorizontalLayoutProps {
  layoutType: string
  router?: RouterProps
}

const HorizontalLayout: React.FC<HorizontalLayoutProps> = (props) => {
  const [isMoreMenu, setIsMoreMenu] = useState(false)
  const navData = useMenuItems()

  let menuItems: MenuItem[] = []
  let splitMenuItems: MenuItem[] = []
  let menuSplitContainer = 6

  navData.forEach((value, key) => {
    if (value["isHeader"]) {
      menuSplitContainer++
    }
    if (key >= menuSplitContainer) {
      const { subItems, ...subVal } = value
      const val: MenuItem = {
        ...subVal,
        subItems: subItems,
        isChildItem: !!subItems,
      }
      splitMenuItems.push(val)
    } else {
      menuItems.push(value)
    }
  })

  menuItems.push({
    id: "more",
    label: "More",
    icon: "ri-briefcase-2-line",
    link: "/#",
    hasSubItems: true,
    isChildItem: false,
    stateVariables: isMoreMenu,
    subItems: splitMenuItems,
    click: (e) => {
      e.preventDefault()
      setIsMoreMenu(!isMoreMenu)
    },
  })

  // Scroll arriba al cambiar de ruta. La activación de menús la maneja React
  // (state compartido en useMenuItems via store externo). Eliminamos initMenu
  // y removeActivation legacy que mutaban el DOM compitiendo con React.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [props.router?.location.pathname])

  return (
    <React.Fragment>
      {(menuItems || []).map((item, key) => {
        return (
          <React.Fragment key={key}>
            {!item["isHeader"] ? (
              item.subItems ? (
                <li className="nav-item">
                  <Link
                    onClick={item.click}
                    className="nav-link menu-link"
                    to={item.link ? item.link : "/#"}
                    role="button"
                    aria-expanded={item.stateVariables}
                    title={item.label}
                  >
                    <i className={item.icon}></i>{" "}
                    <span data-key="t-apps">{item.label}</span>
                  </Link>
                  <div
                    className={`${
                      item.id === "baseUi" && item.subItems.length > 13
                        ? "menu-dropdown mega-dropdown-menu"
                        : "menu-dropdown"
                    } collapse${item.stateVariables ? " show" : ""}`}
                    id={`hm-${item.id}`}
                  >
                    {item.id === "baseUi" && item.subItems.length > 13 ? (
                      <div className="row">
                        {item.subItems &&
                          (item.subItems || []).map((subItem, key) => (
                            <div className="col-lg-4" key={key}>
                              <ul className="nav nav-sm flex-column">
                                <li className="nav-item">
                                  <Link
                                    to={subItem.link}
                                    className="nav-link"
                                  >
                                    {subItem.label}
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          ))}
                      </div>
                    ) : (
                      <ul className="nav nav-sm flex-column test">
                        {item.subItems &&
                          (item.subItems || []).map((subItem, key) => (
                            <React.Fragment key={key}>
                              {!subItem.isChildItem ? (
                                <li className="nav-item">
                                  <Link
                                    to={subItem.link ? subItem.link : "/#"}
                                    className="nav-link"
                                  >
                                    <i className={subItem.icon || "ri-question-line"}></i> <span>{subItem.label}</span>
                                  </Link>
                                </li>
                              ) : (
                                <li className="nav-item">
                                  <Link
                                    onClick={subItem.click}
                                    className="nav-link"
                                    to="/#"
                                    role="button"
                                    aria-expanded={subItem.stateVariables}
                                  >
                                    <i className={subItem.icon || "ri-question-line"}></i> <span>{subItem.label}</span>
                                  </Link>
                                  <div
                                    className={`menu-dropdown collapse${subItem.stateVariables ? " show" : ""}`}
                                    id={`hm-sub-${subItem.id}`}
                                  >
                                    <ul className="nav nav-sm flex-column">
                                      {subItem.subItems &&
                                        (subItem.subItems || []).map(
                                          (subChildItem: MenuItem, key: number) => (
                                            <React.Fragment key={key}>
                                              {!subChildItem.isChildItem ? (
                                                <li className="nav-item">
                                                  <Link
                                                    to={
                                                      subChildItem.link
                                                        ? subChildItem.link
                                                        : "/#"
                                                    }
                                                    className="nav-link"
                                                  >
                                                    {subChildItem.label}
                                                  </Link>
                                                </li>
                                              ) : (
                                                <li className="nav-item">
                                                  <Link
                                                    onClick={subChildItem.click}
                                                    className="nav-link"
                                                    to="/#"
                                                    role="button"
                                                    aria-expanded={subChildItem.stateVariables}
                                                  >
                                                    {" "}
                                                    {subChildItem.label}
                                                  </Link>
                                                  <div
                                                    className={`menu-dropdown collapse${subChildItem.stateVariables ? " show" : ""}`}
                                                    id={`hm-subsub-${subChildItem.id}`}
                                                  >
                                                    <ul className="nav nav-sm flex-column">
                                                      {subChildItem.subItems &&
                                                        (
                                                          subChildItem.subItems ||
                                                          []
                                                        ).map(
                                                          (
                                                            subSubChildItem,
                                                            key
                                                          ) => (
                                                            <li
                                                              className="nav-item apex"
                                                              key={key}
                                                            >
                                                              <Link
                                                                to={
                                                                  subSubChildItem.link
                                                                    ? subSubChildItem.link
                                                                    : "/#"
                                                                }
                                                                className="nav-link"
                                                              >
                                                                {
                                                                  subSubChildItem.label
                                                                }
                                                              </Link>
                                                            </li>
                                                          )
                                                        )}
                                                    </ul>
                                                  </div>
                                                </li>
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                    </ul>
                                  </div>
                                </li>
                              )}
                            </React.Fragment>
                          ))}
                      </ul>
                    )}
                  </div>
                </li>
              ) : (
                <li className="nav-item">
                  <Link
                    className="nav-link menu-link"
                    to={item.link ? item.link : "/#"}
                    title={item.label}
                  >
                    <i className={item.icon}></i> <span>{item.label}</span>
                  </Link>
                </li>
              )
            ) : (
              <li className="menu-title">
                <span data-key="t-menu">{item.label}</span>
              </li>
            )}
          </React.Fragment>
        )
      })}
    </React.Fragment>
  )
}

export default WithRouter(HorizontalLayout)
